var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 628.122,
    y: 269.493,
    width: 133.678,
    height: 16.134,
    rx: 8.067,
    fill: "url(#a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 631.579,
    y: 301.76,
    width: 78.363,
    height: 17.286,
    rx: 8.643,
    fill: "url(#b)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 625.817,
    y: 335.179,
    width: 49.553,
    height: 16.134,
    rx: 8.067,
    fill: "url(#c)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M786 253.359c-5.691-22.948-59.469-56.463-88.208-36.257-8.821-43.719-17.072-70.983-45.892-92.519-28.82-21.537-76.908 6.614-84.631 65.578-7.723-24.239-46.99-56.907-78.534-29.361-29.185 25.489-32.112 68.199-29.064 92.519H786v.04z",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334.877 145.034c2.986-11.863 31.201-29.189 46.279-18.743 4.627-22.601 8.957-36.694 24.077-47.828 15.12-11.133 40.349 3.42 44.401 33.901 4.052-12.53 24.653-29.418 41.203-15.178 15.312 13.176 16.847 35.255 15.248 47.827H334.877v.021z",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.465 269.493c4.389-17.309 45.859-42.587 68.02-27.347 6.802-32.974 13.165-53.537 35.389-69.781 22.223-16.244 59.305 4.989 65.261 49.461 5.955-18.282 36.235-42.921 60.559-22.145 22.506 19.225 24.763 51.439 22.412 69.781H112.465v.031z",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.884 383.139c14.704-24.242 23.169-52.688 23.169-83.111 0-88.631-71.849-160.481-160.481-160.481-88.631 0-160.481 71.85-160.481 160.481s71.85 160.481 160.481 160.481c25.344 0 49.315-5.875 70.627-16.336l-21.689-69.747c-4.577-14.728 10.4-27.926 24.298-21.401l64.076 30.114z",
    fill: "#666AF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.49 363.413h18.439m-18.439-54.739h35.725m-35.725-55.891h110.63",
    stroke: "#fff",
    strokeWidth: 23.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m552.341 479.356-27.93-89.093c-2.945-9.399 6.691-17.821 15.632-13.657l83.296 38.83c9.872 4.599 8.211 19.103-2.45 21.35l-34.292 7.246-12.722 35.724c-3.664 10.257-18.271 9.975-21.534-.4z",
    fill: "#666AF6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 685.584,
    y: 382.21,
    width: 43.076,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(-45 685.584 382.21)",
    fill: "#E1E4E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 702.1,
    y: 382.328,
    width: 15.994,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(-45 702.1 382.328)",
    fill: "#E1E4E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 532.757,
    y: 123.435,
    width: 43.076,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(-45 532.757 123.435)",
    fill: "#E1E4E5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 549.273,
    y: 123.553,
    width: 15.994,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(-45 549.273 123.553)",
    fill: "#E1E4E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 262.865,
    y: 333.083,
    width: 43.076,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(135 262.865 333.083)",
    fill: "#E1E4E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 246.349,
    y: 332.966,
    width: 15.994,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(135 246.349 332.966)",
    fill: "#E1E4E5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 416.959,
    y: 513.625,
    width: 43.076,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(-45 416.959 513.625)",
    fill: "#E1E4E5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 433.474,
    y: 513.742,
    width: 15.994,
    height: 5.019,
    rx: 2.509,
    transform: "rotate(-45 433.474 513.742)",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 697.811,
    y1: 294.672,
    x2: 697.751,
    y2: 251.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 672.431,
    y1: 328.737,
    x2: 672.314,
    y2: 282.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 651.65,
    y1: 360.358,
    x2: 651.488,
    y2: 317.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 629.338,
    y1: 329.599,
    x2: 627.596,
    y2: -30.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 417.07,
    y1: 184.446,
    x2: 417.957,
    y2: -1.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 233.271,
    y1: 326.996,
    x2: 234.557,
    y2: 55.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg31);
export default __webpack_public_path__ + "static/media/31.391d0682b98556bcf2b9ae717f51309e.svg";
export { ForwardRef as ReactComponent };